import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// Admin Pages
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import EventTickets from './pages/admin/EventTickets';
import EventRanking from './pages/admin/EventRanking';

// Sales Pages
import EventSelection from './pages/sales/EventSelection';
import BuyerDetails from './pages/sales/BuyerDetails';
import SaleSuccess from './pages/sales/SaleSuccess';

// Staff Pages
import StaffLogin from './pages/staff/StaffLogin';
import QrScanner from './pages/staff/QrScanner';

//Icons
import { ReactComponent as EALogo } from './assets/ealogo.svg'


function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50 flex flex-col font-sans text-gray-800">
        <header className="bg-indigo-600 text-white p-4 shadow-md sticky top-0 z-10 transition-colors duration-300">
          <div className="container mx-auto flex justify-between items-center">
            <div className='flex flex-row gap-2 items-baseline'>
              <h1 className="text-2xl font-bold tracking-tight">TicketPro</h1>
            </div>
          </div>
        </header>

        <main className="flex-grow container mx-auto p-4 md:p-8 animate-fade-in-up">
          <Routes>
            <Route path="/" element={<Navigate to="/sales" replace />} />

            {/* Sales Flow */}
            <Route path="/sales" element={<EventSelection />} />
            <Route path="/sales/details" element={<BuyerDetails />} />
            <Route path="/sales/success" element={<SaleSuccess />} />

            {/* Admin Flow */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/tickets/:id" element={<EventTickets />} />
            <Route path="/admin/ranking/:id" element={<EventRanking />} />

            {/* Entry Staff Flow */}
            <Route path="/staff/login" element={<StaffLogin />} />
            <Route path="/staff/scan" element={<QrScanner />} />
          </Routes>
        </main>

        <footer className="bg-gray-800 text-gray-300 p-1 text-center mt-auto shadow-inner">
          <div className="flex justify-center items-center">
            <EALogo width={24} height={24} fill='#FFFF' />
            <p className="text-sm">&copy; 2026 EASoftware. All rights reserved.</p>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
